import Vue from 'vue';
import Vuex from 'vuex';
import service from './service/actions';
import wine from './wine/actions';
import client from './client/actions';
import market from './markets/actions';
import brand from './brand/actions';
import auth from './auth/actions';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    service,
    wine,
    client,
    market,
    brand,
    auth
  },
  strict: false
});
